Shopware.Module.register('topdata-llm-connect', {
    type: 'plugin',
    name: 'Topdata LLM Connect',
    title: 'TopdataLlmConnectSW6.nav.mainTitle',
    description: 'TopdataLlmConnectSW6.nav.mainTitle',
    color: '#189eff',
    icon: 'default-lock-key',

    routes: {
        index: {
            path: 'index',
            redirect: {
                name: 'topdata.llm.connect.llm.provider.list',
            },
        },
    },

    navigation: [{
        id: 'topdata-llm-connect',
        label: 'TopdataLlmConnectSW6.nav.mainTitle',
        parent: 'sw-content',
        position: 100,
    }],
});